const pluralize = (count, singular, pluralized) => {
  if (count.toString() === '1') return singular;

  return pluralized || `${singular}s`;
};

export default pluralize;
